module.exports = __webpack_public_path__ + "img/sange_and_yasha.dcfba584.png";